(function(root){
 'use strict';
 function parseVideoURL(value){
  let url;try{url=new URL(value);}catch(_){return null;}
  if(url.protocol!=='https:')return null;
  const host=url.hostname.toLowerCase();let id=null;
  if(host==='youtu.be')id=url.pathname.slice(1);
  if(['youtube.com','www.youtube.com','youtube-nocookie.com','www.youtube-nocookie.com'].includes(host)){
   if(url.pathname==='/watch')id=url.searchParams.get('v');
   else id=url.pathname.match(/^\/(?:shorts|embed)\/([\w-]{11})\/?$/)?.[1];
  }
  if(id&&/^[\w-]{11}$/.test(id))return{kind:'embed',src:'https://www.youtube-nocookie.com/embed/'+id+'?autoplay=1',poster:'https://i.ytimg.com/vi/'+id+'/hqdefault.jpg'};
  if(['vimeo.com','www.vimeo.com','player.vimeo.com'].includes(host)){
   const videoId=url.pathname.match(/^\/(?:video\/)?(\d+)\/?$/)?.[1];
   if(videoId)return{kind:'embed',src:'https://player.vimeo.com/video/'+videoId+'?autoplay=1'};
  }
  if(/\.mp4$/i.test(url.pathname))return{kind:'video',src:url.href};
  return null;
 }
 if(typeof module==='object'&&module.exports)module.exports={parseVideoURL};
 if(!root.customElements||root.customElements.get('arya-product-video'))return;
 class AryaProductVideo extends HTMLElement{
  connectedCallback(){
   if(this.bound)return;this.bound=true;
   const button=this.querySelector('[data-av-play-video]'),target=this.querySelector('[data-av-video-frame]');
   if(!button||!target)return;const video=parseVideoURL(this.dataset.videoUrl);if(!video)return;
   let posterSrc=video.poster;
   if(!posterSrc&&this.dataset.videoPoster){
    try{const candidate=new URL(this.dataset.videoPoster,this.ownerDocument.baseURI);if(candidate.protocol==='https:')posterSrc=candidate.href;}catch(_){}
   }
   if(posterSrc){
    const poster=document.createElement('img');poster.src=posterSrc;poster.alt='';poster.loading='lazy';poster.decoding='async';poster.width=480;poster.height=360;poster.className='av-video-poster'+(video.poster?'':' av-video-poster--product');
    poster.addEventListener('error',()=>poster.remove(),{once:true});button.prepend(poster);
   }
   button.hidden=false;
   button.addEventListener('click',()=>{
    if(video.kind==='video'){
     const media=document.createElement('video');media.src=video.src;if(posterSrc)media.poster=posterSrc;media.controls=true;media.playsInline=true;media.autoplay=true;media.preload='metadata';media.setAttribute('aria-label',this.dataset.videoTitle||'Product video');target.replaceChildren(media);
    }else{
     const frame=document.createElement('iframe');frame.src=video.src;frame.title=this.dataset.videoTitle||'Product video';frame.allow='autoplay; encrypted-media; picture-in-picture; fullscreen';frame.allowFullscreen=true;frame.referrerPolicy='strict-origin-when-cross-origin';target.replaceChildren(frame);
    }
   },{once:true});
  }
 }
 root.customElements.define('arya-product-video',AryaProductVideo);
})(typeof window==='object'?window:globalThis);


